/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, notification, Form, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { getVehicleModelsData } from '../../../../../services/dashboard-services';
import { getEnquirySourcesService, getAuthUserAreasService } from '../../../../../services/master-services';
import InputSelect from '../../../../../components/common/InputSelect';
import { useDispatch, useSelector } from 'react-redux';
import { saveDashboardHomeFilters } from '../../../../auth/slice/authSlice';

const ExchangeFilters = ({ onFiltersChange }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const currentMonthStart = dayjs().startOf('month');
  const currentMonthEnd = dayjs();

  const [vehicleModels, setVehicleModels] = useState([]);
  const [enquirySources, setEnquirySources] = useState([]);
  const [areas, setAreas] = useState([]);
  const [dates, setDates] = useState({
    startDate: currentMonthStart,
    endDate: currentMonthEnd,
  });

  const [filters, setFilters] = useState({
    model_id: '',
    source_id: '',
    area_id: '',
    start_date: currentMonthStart.format('YYYY-MM-DD'),
    end_date: currentMonthEnd.format('YYYY-MM-DD'),
  });

  const launchDate = useSelector((state) => state?.auth?.userData?.launch_date);

  useEffect(() => {
    getVehicleModels();
    getEnquirySources();
    getAuthUserAreas();
    onFiltersChange(filters);
    dispatch(saveDashboardHomeFilters(filters));
  }, []);

  useEffect(() => {
    onFiltersChange(filters);
    dispatch(saveDashboardHomeFilters(filters));
  }, [filters]);

  const getVehicleModels = async () => {
    try {
      const reqData = { makeId: 1 };
      const response = await getVehicleModelsData(reqData, true);
      setVehicleModels(response?.data?.data || []);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    }
  };

  const getEnquirySources = async () => {
    try {
      const response = await getEnquirySourcesService();
      setEnquirySources(response?.data?.data || []);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    }
  };

  const getAuthUserAreas = async () => {
    try {
      const response = await getAuthUserAreasService();
      setAreas(response?.data?.data || []);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    }
  };

  const handleStartDateChange = (date) => {
    // Ensure end date is not before start date
    if (dates?.endDate?.isBefore(date)) {
      notification.error({
        description: 'Start Date cannot be after End Date.',
      });
      return;
    }

    setDates((prevDates) => ({
      ...prevDates,
      startDate: date,
    }));

    setFilters((prevFilters) => ({
      ...prevFilters,
      start_date: date ? date.format('YYYY-MM-DD') : '',
    }));
  };

  const disablePastDates = (current) => {
    return current < dayjs(launchDate, 'DD-MM-YYYY').startOf('month'); // Disable dates before the launch month
  };

  const handleEndDateChange = (date) => {
    // Ensure start date is not after end date
    if (date?.isBefore(dates.startDate)) {
      notification.error({
        description: 'End Date cannot be before Start Date.',
      });
      return;
    }

    setDates((prevDates) => ({
      ...prevDates,
      endDate: date,
    }));

    setFilters((prevFilters) => ({
      ...prevFilters,
      end_date: date ? date.format('YYYY-MM-DD') : '',
    }));
  };

  const handleModelChange = (value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      model_id: value,
    }));
  };

  const handleSourceChange = (value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      source_id: value,
    }));
  };

  const handleAreaChange = (value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      area_id: value,
    }));
  };

  return (
    <Card className='filter-card mb-4'>
      <Form form={form} layout='vertical' name='exchange_search' className='login-form'>
        <div className='login-input-field'>
          <Row gutter={[16, 16]}>
            {/* Model Dropdown */}
            <Col xl={6} lg={12} md={12} sm={24} xs={24}>
              <InputSelect
                allowClear
                name='select_model'
                placeholder='Model'
                options={vehicleModels}
                label='Model'
                optionName={'model_name'}
                className='form-control-ant'
                showSearch
                onChange={handleModelChange}
              />
            </Col>

            {/* Source Enquiry Dropdown */}
            <Col xl={6} lg={12} md={12} sm={24} xs={24}>
              <InputSelect
                allowClear
                name='select_source'
                placeholder='Source Enquiry'
                options={enquirySources}
                label='Source Enquiry'
                optionName={'source'}
                className='form-control-ant'
                showSearch
                onChange={handleSourceChange}
              />
            </Col>

            {/* Area Dropdown */}
            <Col xl={6} lg={12} md={12} sm={24} xs={24}>
              <InputSelect
                allowClear
                name='select_area'
                placeholder='Area'
                options={areas}
                label='Area'
                optionName={'name'}
                className='form-control-ant'
                showSearch
                onChange={handleAreaChange}
              />
            </Col>

            {/* From Date */}
            <Col xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name='start_date' label='From Date'>
                <DatePicker
                  format='DD/MM/YYYY'
                  onChange={handleStartDateChange}
                  value={dates.startDate}
                  placeholder='From Date'
                  disabledDate={disablePastDates}
                  defaultValue={dayjs(currentMonthStart)}
                  allowClear={false}
                />
              </Form.Item>
            </Col>

            {/* To Date */}
            <Col xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name='end_date' label='To Date'>
                <DatePicker
                  format='DD/MM/YYYY'
                  onChange={handleEndDateChange}
                  value={dayjs(dates.endDate)}
                  placeholder='To Date'
                  defaultValue={currentMonthEnd}
                  allowClear={false}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Card>
  );
};

export default ExchangeFilters;
